import './NotesSkeleton.css';

export default function NotesSkeleton({ count = 3 }) {
    return (
        <div className="notes-skeleton">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="note-skeleton-item">
                    <div className="note-skeleton-thumb skeleton-shimmer" />
                    <div className="note-skeleton-info">
                        <div className="note-skeleton-question skeleton-shimmer" />
                        <div className="note-skeleton-question skeleton-shimmer" />
                        <div className="note-skeleton-text skeleton-shimmer" />
                        <div className="note-skeleton-text skeleton-shimmer" />
                        <div className="note-skeleton-text skeleton-shimmer" />
                        <div className="note-skeleton-text skeleton-shimmer" />
                    </div>
                </div>
            ))}
        </div>
    );
}
